import React, { useRef, useEffect, useState } from 'react'
import MusicPlayer from './components/MusicPlayer/MusicPlayer'
import Songs from './components/Songs/Songs'


// songs images

import album1 from '../../assets/albums/a0169049054_2.jpg'
import album2 from '../../assets/albums/a1044223294_2.jpg'
import album3 from '../../assets/albums/a1264983291_2.jpg'
import album4 from '../../assets/albums/a1695987948_2.jpg'
import album5 from '../../assets/albums/a2040795199_2.jpg'
import album6 from '../../assets/albums/a2064756115_65.jpg'
import album7 from '../../assets/albums/a2095466355_2.jpg'
import album8 from '../../assets/albums/a3425592352_2.jpg'
import album9 from '../../assets/albums/a3439793829_2.jpg'
import album10 from '../../assets/albums/glassSm.png'

//  songs src 

import src1 from '../../assets/songs/dead.mp3'
import src2 from '../../assets/songs/reef.mp3'
import src3 from '../../assets/songs/samurai.mp3'
import src4 from '../../assets/songs/hstrings.mp3'
import src5 from '../../assets/songs/call.mp3'
import src6 from '../../assets/songs/soldout.mp3'
import src7 from '../../assets/songs/badluck.mp3'
import src8 from '../../assets/songs/hstrings2.flac'
import src9 from '../../assets/songs/ghost.wav'
import src10 from '../../assets/songs/glass.wav'

const Albums = () => {
  const [songsList] = useState([
    {
      id: 1,
      name: 'Dead Beat',
      img: album1,
      src: src1
    },
    {
      id: 2,
      name: 'Reefers',
      img: album2,
      src: src2
    },
    {
      id: 3,
      name: 'Last Samurai',
      img: album3,
      src: src3
    },
    {
      id: 4,
      name: 'Heart Strings',
      img: album4,
      src: src4
    },
    {
      id: 5,
      name: 'Eternity Cruise',
      img: album5,
      src: src5
    },
    {
      id: 6,
      name: 'Sold out',
      img: album6,
      src: src6
    },
    {
      id: 7,
      name: 'Bad Luck',
      img: album7,
      src: src7
    },
    {
      id: 8,
      name: 'Heart Strings 2',

      img: album8,
      src: src8
    },
    {
      id: 9,
      name: 'Ghost Stories',
      img: album9,
      src: src9
    },
    {
      id: 10,
      name: 'glass',
      img: album10,
      src: src10
    },
  ]);

  const [currentSong, setCurrentSong] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);



  const audioRef = useRef(new Audio(songsList[currentSong].src));

  useEffect(() => {
    const audio = audioRef.current;
    setDuration(audio.duration);
    setCurrentTime(audio.currentTime);
    const handleLoadedData = () => {
      setDuration(audio.duration);
    };

    // Update current time as the song progresses
    const handleTimeUpdate = () => {
      setCurrentTime(audio.currentTime);
    };
    audio.addEventListener("loadeddata", handleLoadedData);
    audio.addEventListener("timeupdate", handleTimeUpdate);

    return () => {
      audio.removeEventListener("loadeddata", handleLoadedData);
      audio.removeEventListener("timeupdate", handleTimeUpdate);
    };
  }, [currentSong]);

  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying)
  }

  const playSong = (index) => {
    setCurrentSong(index);
    audioRef.current.src = songsList[index].src;
    audioRef.current.play();
    setIsPlaying(true);
  };

  const playNext = () => {
    let nextIndex = (currentSong + 1) % songsList.length;
    playSong(nextIndex);
  };

  const playPrevious = () => {
    let prevIndex = (currentSong - 1 + songsList.length) % songsList.length;
    playSong(prevIndex);
  };

  const toggleMute = () => {
    audioRef.current.muted = !isMuted;
    setIsMuted(!isMuted);
  };

  // Seek the audio
  const handleSeek = (event) => {
    const audio = audioRef.current;
    const seekTime = (event.target.value / 100) * duration;
    audio.currentTime = seekTime;
    setCurrentTime(seekTime);
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60).toString().padStart(2, "0");
    return `${minutes}:${seconds}`;
  };
  return (
    <div className='dark:text-white'>
      <section className='max-w-screen-xl p-7 md:flex gap-60'>
        <MusicPlayer toggle={togglePlayPause} isPlaying={isPlaying} currSong={songsList[currentSong].name} toggleMute={toggleMute} isMuted={isMuted} playNext={playNext} playPrevious={playPrevious} handleSeek={handleSeek} currentTime={currentTime} duration={duration} formatTime={formatTime} />
        <Songs songsList={songsList} playSong={playSong} />
      </section>
    </div>
  )
}

export default Albums